module.exports = __webpack_public_path__ + "static/media/Korean-sentence-structure-pattern-1.a23e6109.PNG";